interface EclesiarMarkProps {
  className?: string;
  title?: string;
}

export function EclesiarMark({ className, title = 'Eclesiar' }: EclesiarMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 530 530"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M266.7 104.7c-.3.2-3.6 1.3-7.4 2.3-6.8 1.8-17.8 5-39.3 11.5-6.3 1.9-12.4 3.6-13.5 3.8-1.1.2-2.7.7-3.5 1-1.1.5-18.9 5.7-27.5 8.1-.5.2-1.7.6-2.5.9-.8.3-2.2.7-3 .9-1.2.4-1.5 8.6-1.7 58.3-.2 31.8-.5 58.1-.8 58.3-.2.3-5.5 1.9-11.7 3.7-25.1 7.2-46 13.4-46.4 13.7-.2.2-.5 16.7-.7 36.6-.2 19.9-.5 36.3-.8 36.5-.3.4-42.8 14.1-81.2 26.4-4.8 1.5-8.7 3-8.7 3.3 0 .3 3.9 1.7 8.8 3.2 13.8 4.2 63.9 19.6 72.9 22.4 4.6 1.5 8.3 3.2 8.3 3.8 0 1.1 23.8 9.6 26.8 9.6.7 0 2 .4 3 1 0.9.5 7.8 2.8 15.2 5.1 7.4 2.2 13.7 4.4 14 4.8.3.3 1.1.7 1.9.9.8.2 4 1 7 1.8 3.1.9 6.1 1.7 6.6 1.8 7.4 1.9 10.6 2.8 13.5 3.6 10.9 3.1 31.1 8.5 49.6 13.5l21.1 5.6 16.4-5c9-2.7 27-8.2 39.9-12.1 12.9-3.9 30.5-9.3 39-12 15.5-4.9 33.6-10.5 52.5-16.2 10.5-3.1 17.5-5.3 44.5-13.8 24.5-7.7 33.2-10.4 47.3-14.6 7-2.1 12.7-4.2 12.7-4.6 0-.3-2.6-1.4-5.7-2.3-3.2-.9-12.5-3.9-20.8-6.5-8.2-2.7-21.3-6.9-29-9.3l-14-4.4v-113.2l-5-2.2c-2.7-1.2-10.1-4.6-16.3-7.6-6.2-2.9-11.5-5.3-11.7-5.3-.1 0-4.1-1.8-8.7-3.9-4.5-2.2-17.5-8.2-28.8-13.5l-20.5-9.5v-55.8l-4-1.2c-2.2-.7-7.6-2.5-12-4.1-8.2-3-13-4.6-41.5-14.5-9.1-3.1-19.5-6.8-23.1-8.1-7.3-2.7-10.5-3.5-11.2-2.7Z"
      />
    </svg>
  );
}
